import React from 'react';
import ThemeToggle from './ThemeToggle';

const Header = ({
    isAuthorMode = false,
    onAuthorPortalClick,
    onNavigateHome,
    onNavigateAbout,
    onNavigateNewSite,
    activePage = 'home',
}) => {
    const authorPortalLabel = isAuthorMode ? 'Exit Author Portal' : 'Author Portal';
    const authorPortalMobileLabel = isAuthorMode ? 'Exit' : 'Author Portal';

    return (
        <header className="app-header">
            <div className="header-primary">
                <div className="header-titles">
                    {/* <div className="classified-stamp">UNCENSORED</div>
                    <div className="doc-number">DOC//:2025.10.08//TRANSMISSION:∞</div> */}
                    <h1>The Discerner</h1>
                    <div className="subtitle">Laymen on Agathology and Ponerology</div>
                    {/* <div className="metadata">
                        <span>COPIES: UNLIMITED</span>
                        <span>DISTRIBUTION: UNRESTRICTED</span>
                        <span>VERSION: 1.0.0</span>
                    </div> */}
                </div>
                <div className="header-controls">
                    <nav className="main-nav">
                        <button
                            type="button"
                            className={`nav-link${activePage === 'home' ? ' active' : ''}`}
                            onClick={() => onNavigateHome?.()}
                        >
                            Home
                        </button>
                        <button
                            type="button"
                            className={`nav-link${activePage === 'about' ? ' active' : ''}`}
                            onClick={() => onNavigateAbout?.()}
                        >
                            About
                        </button>
                        <button
                            type="button"
                            className="nav-link"
                            onClick={() => onNavigateNewSite?.()}
                        >
                            New Site →
                        </button>
                    </nav>
                    <button
                        type="button"
                        className={`author-portal-button ${isAuthorMode ? 'active' : ''}`}
                        onClick={onAuthorPortalClick}
                        aria-label={authorPortalLabel}
                    >
                        <span className="author-portal-label author-portal-label--desktop">
                            {authorPortalLabel}
                        </span>
                        <span className="author-portal-label author-portal-label--mobile">
                            {authorPortalMobileLabel}
                        </span>
                    </button>
                    <ThemeToggle />
                </div>
            </div>
        </header>
    );
};

export default Header;
